function previousTimeRange(start: number, end: number): { start: number, end: number } {
  const diff = end - start;
  const newStart = start - diff;
  const newEnd = start;
  
  return { start: newStart, end: newEnd }
}

export default previousTimeRange;
